import { Directive, ElementRef, HostListener, OnInit, Renderer2, Input } from '@angular/core';
import { DocumentService } from 'services';

export interface DocumentLinkConfig {
    size?: 'lg';
}
/**
 * Directive documentLink
 *
 * Applies clich handler with a document link, checks document existence
 *
 * documentLinkConfig<DocumentLinkConfig> is optional
 *
 * Usage:
 *
 * <button [documentLink]="'document-identifier'" [documentLinkConfig]="{size: 'lg'}"></button>
 */
@Directive({
    selector: '[documentLink]'
})
export class DocumentLinkDirective implements OnInit {
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private documentService: DocumentService
    ) {}

    private _documentLink: string;
    private _documentLinkConfig: DocumentLinkConfig = {};

    @Input()
    public set documentLink(value: string) {
        if (!value) {
            throw new Error('documentLink directive config must have a value');
        } else if (typeof value !== 'string') {
            throw new Error('documentLink directive config value must be a string');
        } else {
            this._documentLink = this.documentService.get(value);
        }
    }

    @Input()
    public set documentLinkConfig(config: DocumentLinkConfig) {
        if (config && typeof config === 'object') {
            this._documentLinkConfig = {
                ...this._documentLinkConfig,
                ...config
            };
        } else {
            throw new Error('documentLinkConfig must be a valid object of type DocumentLinkConfig');
        }
    }

    ngOnInit() {
        this.renderer.addClass(
            this.elementRef.nativeElement,
            this._documentLinkConfig.size === 'lg' ? 'document-link-lg' : 'document-link'
        );
    }

    @HostListener('click', ['$event']) onClick(event: Event) {
        event.preventDefault();

        const redirectWindow = window.open(this._documentLink, '_blank');
        redirectWindow.location;
    }
}
